import request from "@/utils/request";
export const queryPage = "/icps/system/sign/dataCollection/supplier/QueryPage";
export const batchUpdateOrDelete =
  "/icps/system/sign/dataCollection/supplier/deletes";
export const updateSortNum = "";
export const saveOrUpdate =
  "/icps/system/sign/dataCollection/supplier/saveOrUpdate";
export const Download = "/icps/system/sign/dataCollection/supplier/exportList";
export const OtherDownload =
  "/icps/system/sign/dataCollection/supplier/exportExample";
export function querysupplierPage(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplier/QueryPage",
    method: "post",
    data,
  });
}
export function saveOrUpdatesupplier(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplier/saveOrUpdate",
    method: "post",
    data,
  });
}
/*周期*/
export function updateEvaluateType(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplier/updateEvaluateType",
    method: "post",
    data,
  });
}
/*查询*/
export function queryIsEvaluateById(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplier/queryIsEvaluateById",
    method: "post",
    data,
  });
}
export function queryIsEvaluat(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplierEvaluate/queryIsEvaluate",
    method: "post",
    data,
  });
}

export function supplierEvaluatesave(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplierEvaluate/save",
    method: "post",
    data,
  });
}
/*模板绑定*/
export function getSupplyEvaluateList(data) {
  return request({
    url:
      "/icps/system/sign/dataCollection/supplyEvaluate/getSupplyEvaluateList",
    method: "post",
    data,
  });
}

export function saveOrUpdateSupplyEvaluateList(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplyEvaluate/saveOrUpdate",
    method: "post",
    data,
  });
}
/*模板维护*/
export function saveSupplyRatingForm(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplyEvaluate/saveSupplyRatingForm",
    method: "post",
    data,
  });
}

export function getSupplyRatingForm(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplyEvaluate/getSupplyRatingForm",
    method: "post",
    data,
  });
}
/*获取评价模板*/
export function getRatingFormByTypeId(data) {
  return request({
    url:
      "/icps/system/sign/dataCollection/supplyEvaluate/getRatingFormByTypeId",
    method: "post",
    data,
  });
}
export function supplierEvaluate(data) {
  return request({
    url: "/icps/system/sign/dataCollection/supplierEvaluate/save",
    method: "post",
    data,
  });
}
export function cooperationSaveOrUpdate(data) {
  //添加协作单位
  return request({
    url: "/icps/system/sign/dataCollection/cooperation/saveOrUpdate",
    method: "post",
    data,
  });
}
export function queryListsByPid(data) {
  //查询list协作单位
  return request({
    url: "/icps/system/sign/dataCollection/cooperation/queryListsByPid",
    method: "post",
    data,
  });
}
/*获取供应商详情*/
export function QueryOneByid(data) {
  //查询list协作单位
  return request({
    url: "/icps/system/sign/dataCollection/supplier/QueryOneByid",
    method: "post",
    data,
  });
}
/*删除协作单位*/
export function deletesCooperation(data) {
  //查询list协作单位
  return request({
    url: "/icps//system/sign/dataCollection/cooperation/deletesCooperation",
    method: "post",
    data,
  });
}
